import { Loader } from 'semantic-ui-react';

function Loading({
  style = {},
  fullPage = false,
}: {
  style?: React.CSSProperties;
  fullPage?: boolean;
}) {
  if (fullPage) {
    return (
      <div
        className="absolute top-0 left-0 width-100 height-100 flex justify-center align-center"
        style={{ backgroundColor: 'rgba(250,250,250,0.7)', zIndex: 10 }}
        data-testid="semantic-loader"
      >
        <Loader inline size="large" active style={style} data-testid="Loading indicator" />
      </div>
    );
  }
  return <Loader inline size="small" active style={style} data-testid="Loading indicator" />;
}

export default Loading;
